/*
 * File: application.ts
 * Created: 2026-02-21 17:22:39
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2026-03-26 17:41:56
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

interface Config {
    translationFileLimit: string;
    supportEmail: string;
    topupMinimumAmount: number;

    maintainance?: Date;
}

var config: Config = {
    translationFileLimit: "100MB",
    supportEmail: "sales01@hcutech.com",
    topupMinimumAmount: 100,
};
export default config;
